/**
 * @fileoverview Shared 6-category × 2-channel notification matrix grid
 * (MOR-716). Used by the global settings dialog and the per-task bell
 * popover.
 */

import { Checkbox } from "@/ui/primitives/checkbox";

export const NOTIFICATION_CATEGORIES = [
  { key: "assignment", label: "Assignment" },
  { key: "status", label: "Status changes" },
  { key: "comments", label: "Comments" },
  { key: "dates", label: "Date changes" },
  { key: "priority", label: "Priority" },
  { key: "edits", label: "Other edits" },
] as const;

export type NotificationCategoryKey =
  (typeof NOTIFICATION_CATEGORIES)[number]["key"];

export type ChannelPair = { inApp: boolean; email: boolean };
export type NotificationMatrix = Record<NotificationCategoryKey, ChannelPair>;

export function CategoryMatrix({
  matrix,
  disabled,
  onToggle,
}: {
  matrix: NotificationMatrix;
  disabled?: boolean;
  onToggle: (key: NotificationCategoryKey, channel: "inApp" | "email") => void;
}) {
  return (
    <div className="space-y-1.5">
      <div className="grid grid-cols-[1fr_3.5rem_3.5rem] gap-x-2 text-xs text-muted-foreground">
        <span />
        <span className="text-center">In-app</span>
        <span className="text-center">Email</span>
      </div>
      {NOTIFICATION_CATEGORIES.map((c) => (
        <div
          key={c.key}
          className="grid grid-cols-[1fr_3.5rem_3.5rem] items-center gap-x-2"
        >
          <span className="text-sm">{c.label}</span>
          <div className="flex justify-center">
            <Checkbox
              checked={!disabled && matrix[c.key].inApp}
              disabled={disabled}
              onCheckedChange={() => onToggle(c.key, "inApp")}
            />
          </div>
          <div className="flex justify-center">
            <Checkbox
              checked={!disabled && matrix[c.key].email}
              disabled={disabled}
              onCheckedChange={() => onToggle(c.key, "email")}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
